import { render } from "./booking-menu.vue?vue&type=template&id=edd53088&scoped=true"
import script from "./booking-menu.vue?vue&type=script&lang=js"
export * from "./booking-menu.vue?vue&type=script&lang=js"

import "./booking-menu.vue?vue&type=style&index=0&id=edd53088&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd53088"]])

export default __exports__